import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  /*the following values should be as same as in mixins.scss*/
  private readonly MOBILE_VIEW = '(max-width: 500px)';
  private readonly TABLET_VIEW = '(max-width: 900px)';
  private readonly DESKTOP_VIEW = '(max-width: 1600px)';
  private readonly XL_SCREEN_VIEW = '(max-width: 2200px)';

  public isPhoneViewObservable: Observable<boolean>;

  public isTabletViewObservable: Observable<boolean>;

  public isDesktopViewObservable: Observable<boolean>;

  public isXlScreenViewObservable: Observable<boolean>;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.isPhoneViewObservable = this.breakpointObserver
      .observe(this.MOBILE_VIEW)
      .pipe(map((result) => result.matches));

    this.isTabletViewObservable = this.breakpointObserver
      .observe(this.TABLET_VIEW)
      .pipe(map((result) => result.matches));

    this.isDesktopViewObservable = this.breakpointObserver
      .observe(this.DESKTOP_VIEW)
      .pipe(map((result) => result.matches));

    this.isXlScreenViewObservable = this.breakpointObserver
      .observe(this.XL_SCREEN_VIEW)
      .pipe(map((result) => result.matches));
  }

  public isPhoneView(): boolean {
    return this.breakpointObserver.isMatched(this.MOBILE_VIEW);
  }

  public isTabletView(): boolean {
    return this.breakpointObserver.isMatched(this.TABLET_VIEW);
  }

  public isDesktopView(): boolean {
    return this.breakpointObserver.isMatched(this.DESKTOP_VIEW);
  }

  public isXlScreenView(): boolean {
    return this.breakpointObserver.isMatched(this.XL_SCREEN_VIEW);
  }
}
